import { render } from "./ScrollToTopPopupButton.vue?vue&type=template&id=7e0cabb6&scoped=true"
import script from "./ScrollToTopPopupButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopPopupButton.vue?vue&type=script&lang=js"

import "./ScrollToTopPopupButton.vue?vue&type=style&index=0&id=7e0cabb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0cabb6"]])

export default __exports__